import axios from "axios";
import { authHeader } from "../_helpers";
import {
  buildRelations,
  buildFilters,
  buildOrders,
  handleResponse,
} from "../_helpers";

import EnvironmentUtil from "../_utils/EnvironmentUtil";

export const dataService = {
  getData,
  getOneData,
  //   getOneUtility,
  //   addUtility,
  //   deleteOneUtility,
  //   updateUtility,
  //   getEndpoint,
};

const apiClient = axios.create({
  /**
   * Import the config from the App/Config/index.js file
   */
  baseURL: EnvironmentUtil.getEnvObject().url,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: authHeader(),
  },
  timeout: 12000,
});

function getData(model, options) {
  let filters = options.filters || [];
  let relations = options.relations || [];
  let orders = options.orders || [];
  let perPage = options.perPage || 10;
  let page = options.page || 1;
  const params = options.params;

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const filterStrings = buildFilters(filters);
  const filterString = Array.isArray(filterStrings)
    ? filterStrings.join("&")
    : "null";
  const relationStrings = buildRelations(relations);
  const relationString = Array.isArray(relationStrings)
    ? relationStrings.join("&")
    : "null";
  const orderStrings = buildOrders(orders);
  const orderString = Array.isArray(orderStrings)
    ? orderStrings.join("&")
    : "null";

  return apiClient
    .get(
      `/data/${model}?per_page=${perPage}&page=${page}&${filterString}&${relationString}&${orderString}&${params}`
    )
    .then(handleResponse)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
}

function getOneData(model, id, options) {
  let filters = (options && options.filters) || [];
  let relations = (options && options.relations) || [];

  const filterStrings = buildFilters(filters);
  const filterString = Array.isArray(filterStrings)
    ? filterStrings.join("&")
    : "null";
  const relationStrings = buildRelations(relations);
  const relationString = Array.isArray(relationStrings)
    ? relationStrings.join("&")
    : "null";

  return apiClient
    .get(`/data/${model}/${id}?${filterString}&${relationString}`)
    .then(handleResponse)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
}

// function addUtility(utilityName, data) {
//   const requestOptions = {
//     method: "POST",
//     headers: { ...authHeader(), "Content-Type": "application/json" },
//     body: JSON.stringify(data),
//   };

//   const url = getEnvironmentURL();
//   return fetch(`${url}/api/${utilityName}`, requestOptions)
//     .then(handleResponse)
//     .then((response) => {
//       return response;
//     });
// }

// function deleteOneUtility(utilityName, id, options) {
//   const requestOptions = {
//     method: "DELETE",
//     headers: authHeader(),
//   };

//   const url = getEnvironmentURL();
//   return fetch(`${url}/api/${utilityName}/${id}`, requestOptions)
//     .then(handleResponse)
//     .then((response) => {
//       console.log("delete response", response.status);
//       return response;
//     });
// }

// function updateUtility(utilityName, id, item) {
//   const requestOptions = {
//     method: "PUT",
//     headers: { ...authHeader(), "Content-Type": "application/json" },
//     body: JSON.stringify(item),
//   };

//   const url = getEnvironmentURL();
//   return fetch(`${url}/api/${utilityName}/${id}`, requestOptions)
//     .then(handleResponse)
//     .then((response) => {
//       return response;
//     });
// }

// function getEndpoint(path, method, options = {}) {
//   let relations = (options && options.relations) || [];
//   let params = (options && options.params) || "";
//   let body = (options && options.body) || null;

//   const requestOptions = {
//     method,
//     headers: {
//       ...authHeader(),
//       "Content-Type": "application/json",
//       Accept: "application/json",
//     },
//     body: body && JSON.stringify(body),
//   };

//   const relationStrings = buildRelations(relations);
//   const relationString = Array.isArray(relationStrings)
//     ? relationStrings.join("&")
//     : "null";

//   const url = getEnvironmentURL();
//   return fetch(`${url}/${path}?${relationString}&${params}`, requestOptions)
//     .then(handleResponse)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       throw error;
//     });
// }
